export default function Count({ num = 0, className = '' }) {
  // Array com 5 posições (índices de 0 a 4)
  const items = Array.from({ length: 5 });

  return (
    <div className={`flex flex-row justify-center gap-2 my-2 ${className}`}>
      {items.map((_, index) => (
        <div
          key={index}
          className={`w-[15px] h-[15px] rounded-none border-2 ${
            index < num ? 'bg-primary border-primary' : 'bg-muted dark:bg-neutral-700 border-border dark:border-neutral-600'
          }`}
        />
      ))}
    </div>
  );
}